import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Grid,
  Box,
  TableContainer,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import StatusTextDispaly from "../models/status/DeliveryCompleted";
import { getRefQty, getStdQty, getVariance } from "../sasl/common/variance";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import { presentFormatedData } from "../functionalComponents/dataFormatFunctions";
import getColor from "../sasl/models/status/statusColors";
import StyledButton from "../models/Button";
import { useDispatch } from "react-redux";
import BackDropLoading from "../models/BackDrop";
import { DESTROY_BACKDROP, OPEN_BACKDROP } from "../../../containers/actions/types";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    margin: "20px auto",
    padding: theme.spacing(2),
  },
  headerAuditText: {
    marginBottom: theme.spacing(2),
    textAlign: "center",
    fontWeight: "500",
  },
  button: {
    backgroundColor: "#f5b7b1",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#f1948a",
    },
  },
  table: {
    marginTop: theme.spacing(2),
  },
  statusButton: {
    backgroundColor: "#58d68d",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#45b39d",
    },
  },
  approvedStatus: {
    backgroundColor: "#76d7c4",
    color: "#fff",
    borderRadius: "5px",
    padding: "5px 10px",
  },
  negotiationStatus: {
    backgroundColor: "#f7b7a3",
    color: "#fff",
    borderRadius: "5px",
    padding: "5px 10px",
  },
  headerTable: {
    marginBottom: theme.spacing(2),
    backgroundColor: "#f8f9f9",
    borderRadius: "5px",
    padding: theme.spacing(2),
  },
  headerItem: {
    marginBottom: theme.spacing(1),
  },
  headerLabel: {
    fontWeight: "bold",
  },
  headerContainer: {
    margin: "20px auto",
    padding: "16px",
    backgroundColor: "#f8f9fa",
    boxShadow: "none",
    border: "0.5px solid #BEBEBEC7",
  },
  table: {
    width: "100%",
  },
  header: {
    fontWeight: "500",
    border: "none",
  },
  value: {
    fontSize: "14px",
    color: "#212529",
    border: "none",
  },
  status: {
    fontSize: "14px",
    borderRadius: "20px",
    padding: "4px 12px",
    textAlign: "center",
    display: "inline-block",
    whiteSpace: "nowrap",
  },
}));

const BackwardGenealogy = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { cmoDetails, productData, batchDetails } = props;
  const [tableData, setTableData] = useState([]);
  const [bomDetails, setBOMDetails] = useState([]);
  const [batchData, setBatchData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [downloadError, setDownloadError] = useState(null);
  //   const cmoDetails = {
  //     organization_name: "Blauer Pharmaceuticals Inc",
  //     organization_id: 3,
  //     organizationName: "Blauer Pharmaceuticals Inc",
  //     organizationId: 3,
  //     vendorPlant: 762,
  //   };
  //   const productData = {
  //     fgMaterialCode: 222,
  //     fgMaterialName: "wwwww",
  //   };
  //   const batchDetails = {
  //     vendorBatchNumber: "23bug3",
  //     batchSize: 33,
  //     batchUOM: "oww",
  //     statusDescription: "created",
  //     schrockenDeliveryScheduleBatchID: 10698,
  //     schrockenDeliveryScheduleID: 79788,
  //     bomConsumptionAddedIndicator: true,
  //     statusID: 2,
  //     };

  useEffect(() => {
    setLoading(true);
    const data = {
      schrockenDeliveryScheduleBatchID: parseInt(
        batchDetails.schrockenDeliveryScheduleBatchID
      ),
      schrockenDeliveryScheduleID: batchDetails.schrockenDeliveryScheduleID,
      bomConsumptionAddedIndicator: batchDetails.bomConsumptionAddedIndicator,
    };

    let bomRecipeFetch = {
      schrockenDeliveryScheduleID: parseInt(
        batchDetails.schrockenDeliveryScheduleID
      ),
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBOMConsumptionDetails`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          setTableData(
            res.data.data?.bomConsumptionDetails
              ? res.data.data?.bomConsumptionDetails
              : []
          );
          setBatchData(res.data.data);
          axios
            .post(
              `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBOMDetails`,
              bomRecipeFetch
            )
            .then((res) => {
              if (res.data.status) {
                setBOMDetails(res.data.data ? res.data.data : []);
                setLoading(false);
              } else {
                setError(true);
              }
            })
            .catch((err) => {
              setError(true);
              //console.log(err);
            });
        } else {
          setError(true);
        }
      })
      .catch((err) => {
        //console.log(err);
        setError(true);
      });
  }, []);
  // const auditReportObject = {
  //   headerData: {
  //     cmoName: "Resilient Generics Limited",
  //     plantId: "1233",
  //     productCodeDescription: "50065905 / KALMIC DS PREMIX 30ML (S)",
  //     batchNumber: "BCH060103",
  //     batchSize: 3,
  //     uom: "BOX",
  //     batchStatus: "Goods Received",
  //   },
  //   tableData: [
  //     {
  //       materialCodeDescription: "40000057 / ASPARTAME USP",
  //       uom: "KG",
  //       standardQuantity: 30,
  //       consumptionDetails: [
  //         {
  //           rmPmBatchNumber: "NA",
  //           consumedQuantity: 0,
  //         },
  //         {
  //           rmPmBatchNumber: "0000123456",
  //           consumedQuantity: 2,
  //         },
  //       ],
  //     },
  //     {
  //       materialCodeDescription: "40000011 / MAGNESIUM STEARATE USP",
  //       uom: "KG",
  //       standardQuantity: 42,
  //       consumptionDetails: [
  //         {
  //           rmPmBatchNumber: "0000003246",
  //           consumedQuantity: 4,
  //         },
  //         {
  //           rmPmBatchNumber: "0000003247",
  //           consumedQuantity: 2,
  //         },
  //         {
  //           rmPmBatchNumber: "0000003248",
  //           consumedQuantity: 1,
  //         },
  //       ],
  //     },
  //     {
  //       materialCodeDescription: "40000019 / REFINED SUNFLOWER OIL USP",
  //       uom: "L",
  //       standardQuantity: 54,
  //       consumptionDetails: [
  //         {
  //           rmPmBatchNumber: "0000005678",
  //           consumedQuantity: 5,
  //         },
  //         {
  //           rmPmBatchNumber: "0000005679",
  //           consumedQuantity: 3,
  //         },
  //       ],
  //     },
  //     {
  //       materialCodeDescription: "40000080 / HONEYCOMB 38X38X60MM KALMIC DS",
  //       uom: "EA",
  //       standardQuantity: 51,
  //       consumptionDetails: [
  //         {
  //           rmPmBatchNumber: "0000009012",
  //           consumedQuantity: 6,
  //         },
  //       ],
  //     },
  //   ],
  // };

  // Create reqObj for download report middleware
  const createAuditReportObject = () => {
    return {
      headerData: {
        cmoName: presentFormatedData(cmoDetails?.organization_name),
        plantId: presentFormatedData(cmoDetails?.vendorPlant),
        productCodeDescription:
          productData?.fgMaterialCode && productData?.fgMaterialName
            ? `${productData?.fgMaterialCode} / ${productData?.fgMaterialName}`
            : " - / - ",
        batchNumber: presentFormatedData(batchDetails.vendorBatchNumber),
        batchSize: presentFormatedData(batchDetails.batchSize),
        uom: presentFormatedData(batchDetails.batchUOM),
        batchStatus: batchDetails.statusDescription || "-NA-",
      },
      tableData: tableData.map((item) => {
        let refQty = getRefQty({
          materialCode: item.BomComponentCode,
          bomData: bomDetails.bomComponentDetails,
        });
        let stdQty = getStdQty(
          batchData.batchSize,
          presentFormatedData(bomDetails.fgRefQuantity),
          refQty
        );
        return {
          materialCodeDescription: `${item.BomComponentCode} / ${item.BomComponentName}`,
          uom: item.BomComponentRefUOM,
          standardQuantity: presentFormatedData(stdQty, ""),
          consumptionDetails: item.consumptionBatchNumbers.map((batch) => ({
            rmPmBatchNumber: presentFormatedData(
              batch.componentBatchNumber,
              ""
            ),
            consumedQuantity: presentFormatedData(
              batch.BomComponentConsumedQuantity,
              ""
            ),
          })),
        };
      }),
    };
  };
  const downloadReport = () => {
    setDownloadError(null);

    const reqObj = createAuditReportObject();
    // console.log("🚀 ~ downloadReport ~ reqObj:", reqObj);

    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait. Downloading the file....",
    });
    
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadBackwardGeneologyExcelFile`,
        reqObj
      )
      .then((res) => {
        // throw new Error("Mock Error ");
        if (res.data.status) {
          const byteCharacters = atob(res.data.fileData);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          // Create a download link and trigger the download
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = res.data.fileName || "report.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setDownloadError("There is an error in downloading excel file");
          //console.log("There is an error in downloading excel file");
        }
        dispatch({
                          type: DESTROY_BACKDROP,
                        });
      })
      .catch((err) => {
        setDownloadError(err);
        console.error(err.message);
        dispatch({
                          type: DESTROY_BACKDROP,
                        });
      });
  };

  return (
    <React.Fragment>
      <BackDropLoading />
    <Paper className={classes.container}>
      <Typography variant="h5" className={classes.headerAuditText}>
        Audit Report
      </Typography>
      {
        //         loading ? <div style={{ width: '100%', textAlign: 'center' }}>
        // <CircularProgress />
        //       </div> : error ? <div style={{border: '2px solid #FF0000',
        //                 backgroundColor: '#FFF0F0',}}>
        //           <Typography>
        //           Something went wrong. Please try again later.
        //           </Typography>
        //         </div>
        //             :
        batchDetails && Object.keys(batchDetails).length > 0 ? (
          <React.Fragment>
            {/* Header Section */}
            <Paper className={classes.headerContainer}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left" className={classes.header}>
                      CMO Name
                    </TableCell>
                    <TableCell align="left" className={classes.header}>
                      Plant ID
                    </TableCell>
                    <TableCell align="left" className={classes.header}>
                      Product code / description
                    </TableCell>
                    <TableCell align="left" className={classes.header}>
                      Batch Number
                    </TableCell>
                    <TableCell align="right" className={classes.header}>
                      Batch Size
                    </TableCell>
                    <TableCell align="left" className={classes.header}>
                      UoM
                    </TableCell>
                    <TableCell align="center" className={classes.header}>
                      Batch Status
                    </TableCell>
                    <TableCell
                      align="center"
                      className={classes.header}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell align="left" style={{ border: "none" }}>
                      <Typography className={classes.value}>
                        {presentFormatedData(cmoDetails?.organization_name)}
                      </Typography>
                    </TableCell>
                    <TableCell align="left" style={{ border: "none" }}>
                      <Typography className={classes.value}>
                        {presentFormatedData(cmoDetails?.vendorPlant)}
                      </Typography>
                    </TableCell>
                    <TableCell align="left" style={{ border: "none" }}>
                      <Typography className={classes.value}>
                        {productData?.fgMaterialCode &&
                        productData?.fgMaterialName
                          ? `${productData?.fgMaterialCode} / ${productData?.fgMaterialName}`
                          : " - / - "}
                      </Typography>
                    </TableCell>
                    <TableCell align="left" style={{ border: "none" }}>
                      <Typography className={classes.value}>
                        {presentFormatedData(batchDetails.vendorBatchNumber)}
                      </Typography>
                    </TableCell>
                    <TableCell align="right" style={{ border: "none" }}>
                      <Typography className={classes.value}>
                        {presentFormatedData(batchDetails.batchSize)}
                      </Typography>
                    </TableCell>
                    <TableCell align="left" style={{ border: "none" }}>
                      <Typography className={classes.value}>
                        {presentFormatedData(batchDetails.batchUOM)}
                      </Typography>
                    </TableCell>
                    <TableCell align="center" style={{ border: "none" }}>
                      <StatusTextDispaly
                        statusText={
                          batchDetails.statusDescription
                            ? batchDetails.statusDescription
                            : "-NA-"
                        }
                        bgColor={getColor(batchDetails.statusID)}
                      />
                    </TableCell>
                    <TableCell style={{ border: "none" }}>
                      <StyledButton
                        color="primary"
                        //   className={classes.search}
                        style={{ borderRadius: "2rem" }}
                        onClick={downloadReport}
                      >
                        Download report
                      </StyledButton>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
            {downloadError && (
              <Box
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                  marginBottom: "1.5em",
                }}
              >
                {" "}
                <Typography variant="body2">
                  Something went wrong. Please try again later.
                </Typography>
              </Box>
            )}
            {/* Audit Report Table */}
            <TableContainer style={{ maxHeight: 500 }}>
              <Table stickyHeader className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="left"
                      style={{
                        background: "#FFE4CC",
                        border: "2px solid #FFA95E",
                        borderRight: "none",
                        // borderLeft: "none",
                      }}
                    >
                      Material code / description
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        background: "#FFE4CC",
                        border: "2px solid #FFA95E",
                        borderRight: "none",
                        borderLeft: "none",
                      }}
                    >
                      UOM
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{
                        background: "#FFE4CC",
                        border: "2px solid #FFA95E",
                        borderRight: "none",
                        borderLeft: "none",
                      }}
                    >
                      Standard Quantity
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        background: "#FFE4CC",
                        border: "2px solid #FFA95E",
                        borderRight: "none",
                        borderLeft: "none",
                      }}
                    >
                      RM/PM batch number
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{
                        background: "#FFE4CC",
                        border: "2px solid #FFA95E",
                        // borderRight: "none",
                        borderLeft: "none",
                      }}
                    >
                      Consumed quantity
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading === true ? (
                    <TableRow style={{ height: 150 }}>
                      <TableCell colSpan={5}>
                        <div style={{ textAlign: "center" }}>
                          <CircularProgress color="primary" thickness={7} />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : error ? (
                    <TableRow
                      style={{
                        border: "2px solid rgb(255,0,0)",
                        backgroundColor: "rgb(255,240,240)",
                        Opacity: 1,
                        textAlign: "center",
                        padding: "0.8rem",
                        fontSize: "0.875rem",
                      }}
                    >
                      <TableCell colSpan={6} align="center">
                        {"Something went wrong. Please try again."}
                      </TableCell>
                    </TableRow>
                  ) : tableData &&
                    bomDetails?.bomComponentDetails &&
                    tableData.length > 0 &&
                    bomDetails.bomComponentDetails.length > 0 ? (
                    tableData.map((item, i) => {
                      let refQty = getRefQty({
                        materialCode: item.BomComponentCode,
                        bomData: bomDetails.bomComponentDetails,
                      });
                      let stdQty = getStdQty(
                        batchData.batchSize,
                        presentFormatedData(bomDetails.fgRefQuantity),
                        refQty
                      );

                      return (
                        <React.Fragment key={i}>
                          <TableRow>
                            <TableCell
                              scope="row"
                              align="left"
                              rowSpan={
                                item.consumptionBatchNumbers.length > 1 &&
                                item.consumptionBatchNumbers.length
                              }
                            >
                              {item.BomComponentCode}
                              {" / "}
                              {item.BomComponentName}
                            </TableCell>
                            <TableCell
                              align="left"
                              rowSpan={
                                item.consumptionBatchNumbers.length > 1 &&
                                item.consumptionBatchNumbers.length
                              }
                            >
                              {item.BomComponentRefUOM}
                            </TableCell>
                            <TableCell
                              align="right"
                              rowSpan={
                                item.consumptionBatchNumbers.length > 1 &&
                                item.consumptionBatchNumbers.length
                              }
                            >
                              {presentFormatedData(stdQty, "")}
                            </TableCell>
                            {/* <TableCell align='right'>
                              {presentFormatedData(stdQty, 'NA')}
                            </TableCell> */}
                            <TableCell align="left">
                              {presentFormatedData(
                                item.consumptionBatchNumbers[0]
                                  .componentBatchNumber,
                                ""
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {presentFormatedData(
                                item.consumptionBatchNumbers[0]
                                  .BomComponentConsumedQuantity,
                                ""
                              )}
                            </TableCell>
                          </TableRow>
                          {item.consumptionBatchNumbers
                            .slice(1)
                            .map((val, index) => (
                              <TableRow key={index}>
                                {/* <TableCell align='left' style={{borderBottom: item.consumptionBatchNumbers.length > index + 2  &&'none'}}></TableCell>
                    <TableCell align='left' style={{borderBottom: item.consumptionBatchNumbers.length > index + 2  &&'none'}}></TableCell>
                                                              <TableCell align='left' style={{ borderBottom: item.consumptionBatchNumbers.length > index + 2 && 'none' }}></TableCell> */}
                                <TableCell align="left">
                                  {presentFormatedData(
                                    val.componentBatchNumber,
                                    ""
                                  )}
                                </TableCell>
                                <TableCell align="right">
                                  {presentFormatedData(
                                    val.BomComponentConsumedQuantity,
                                    ""
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} style={{ textAlign: "center" }}>
                        No Records Found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </React.Fragment>
        ) : (
          <div>
            <Typography
              style={{
                textAlign: "center",
                border: "1px solid",
                padding: "2rem",
              }}
            >
              No Records Found.
            </Typography>
          </div>
        )
      }
    </Paper>

    </React.Fragment>
  );
};

export default BackwardGenealogy;
